import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class ModalpopService {
  constructor(private dialog: MatDialog) { }

  openPopup<T>(component: any, data: any): MatDialogRef<any> {
    return this.dialog.open(component, {
      width: '550px',
      // tslint:disable-next-line:object-literal-shorthand
      data: data,
      disableClose: true
    });
  }

  closePopup(dialogRef: MatDialogRef<any>) {
    dialogRef.close('closed forcefully');
  }
}
